"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var INPUT = {
    /**
     * 判断用户输入的是否有emoj表情
     * @param inputValue
     * @returns {boolean}
     */
    isEmojiCharacter: function (substring) {
        var newSubstring = substring.trim();
        for (var i = 0; i < newSubstring.length; i++) {
            var hs = newSubstring.charCodeAt(i);
            var ls = newSubstring.charCodeAt(i + 1);
            if (hs >= 0xd800 && hs <= 0xdbff) {
                if (newSubstring.length > 1) {
                    var uc = (hs - 0xd800) * 0x400 + (ls - 0xdc00) + 0x10000;
                    if (uc >= 0x1d000 && uc <= 0x1f77f) {
                        return true;
                    }
                }
            }
            else if (newSubstring.length > 1) {
                if (ls === 0x20e3) {
                    return true;
                }
            }
            else {
                if ((hs >= 0x2100 && hs <= 0x27ff) ||
                    (hs >= 0x2b05 && hs <= 0x2b07) ||
                    (hs >= 0x2934 && hs <= 0x2935) ||
                    (hs >= 0x3297 && hs <= 0x3299)) {
                    return true;
                }
                if (hs === 0xa9 ||
                    hs === 0xae ||
                    hs === 0x303d ||
                    hs === 0x3030 ||
                    hs === 0x2b55 ||
                    hs === 0x2b1c ||
                    hs === 0x2b1b ||
                    hs === 0x2b50) {
                    return true;
                }
            }
        }
        return false;
    },
    /**
     * 过滤表情
     * @param {any} str
     * @returns {string}
     */
    trimEmojiText: function (str) {
        var emojiReg = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\u00A9|\u00AE|\u3030/gi;
        return str.replace(emojiReg, '');
    },
    /**
     * 过滤非中文，英文，数字，非半角全角标点符号
     * @param {any} str
     * @returns {string}
     */
    trimSpecialText: function (str) {
        // 0020—007F基本拉丁字母 2200—22FF数学运算符 FF00—FFEF半角及全角形式 4E00—9FFF中日韩统一表意文字
        // 表情大部分两字符编码，单字符节也不在上区间中 [\uD800-\uDBFF][\uDC00-\uDFFF]
        return str.replace(/[^\u0020-\u22FF^\u4e00-\u9FFF^\uFF00—\uFFEF]/g, '');
    }
};
exports.default = {
    name: 'utils-check-input',
    install: function (UIP) {
        UIP.checkModule('utils', 'check', 'INPUT');
        UIP.utils.check.INPUT = INPUT;
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/utils-check-input/dist/index.js
// module id = szSM
// module chunks = 1